import React, { Component } from "react";
import { Redirect } from "react-router";
import { compose } from "recompose";
import { connect } from "react-redux";
import Sidebar from "react-sidebar";
import { Link } from "react-router-dom";
import Typography from "material-ui/Typography";
import AppBar from "material-ui/AppBar";
import Toolbar from "material-ui/Toolbar";
import IconButton from "material-ui/IconButton";
import Button from "material-ui/Button";
import Drawer from "material-ui/Drawer";
import Icon from "material-ui/Icon";
import List, {
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader
} from "material-ui/List";
import Divider from "material-ui/Divider";
import { withStyles } from "material-ui/styles";
import styles from "./styles";

import { getNavigationStatus, setNavigationStatus } from "../../redux/actions";

/* Constants */
import {
  ROLES_ALL,
  ROLES_IDEAL,
  ROLES_IDEAL_ADMIN,
  ROLES_IDEAL_SUPPORT,
  ROLES_CLIENT,
  ROLES_CLIENT_ADMIN,
  ROLES_CLIENT_MANAGER,
  ROLES_CLIENT_USER,
  HELP_PAGE_URL,
  SUPPORT_PAGE_URL
} from "../../common/constants";

const sidebarStyles = {
  sidebar: {
    backgroundColor: "#efefef"
  }
};

const NavigationItem = props => {
  const { classes, to, allowed, profile, children } = props;
  return allowed.filter(n => profile.roles.includes(n)).length ? (
    <ListItem button component={Link} to={to}>
      {children}
    </ListItem>
  ) : (
    <div></div>
  );
};
class Navigation extends React.Component {
  navigate(page) {
    return <Redirect to={`/${page}`} />;
  }

  toggleMenu() {
    this.props.set(!this.props.status);
  }

  render() {
    const { classes, status, profile, children, translate, teamViewerUrl, activeFeatures } = this.props;
    const hasLrpFreeFeatures = activeFeatures?.some(feature => feature.featureName === 'lrp_free_features');
    const isIdealAdmin =
      profile && profile.roles && profile.roles === "idealadmin" ? true : false;
    const isIdealSupport =
      profile && profile.roles && profile.roles === "idealsupport" ? true : false;
    return (
      <div className={classes.root}>
        <Drawer
          anchor="left"
          open={status}
          className={classes.root}
          onClose={this.toggleMenu.bind(this)}
        >
          <div className={classes.drawerInner}>
            <div className={classes.drawerHeader}>
              <Typography type="title" color={"inherit"}>
                {translate("navigation_title")}
              </Typography>
              <Button onClick={this.toggleMenu.bind(this)} mini>
                <Icon>close</Icon>
              </Button>
            </div>
            <div className={classes.drawerContent}>
              <List onClick={() => this.toggleMenu()}>
                {hasLrpFreeFeatures && <NavigationItem
                  button
                  component={Link}
                  to="/home"
                  allowed={ROLES_CLIENT}
                  profile={profile}
                >
                  <Icon color={"primary"}>home</Icon>
                  <ListItemText primary={translate("home")} />
                </NavigationItem>}
                <NavigationItem
                  button
                  component={Link}
                  to="/jobs"
                  allowed={ROLES_CLIENT}
                  profile={profile}
                >
                  <Icon color={"primary"}>settings_input_component</Icon>
                  <ListItemText primary={translate("general_jobs")} />
                </NavigationItem>
                {this.props.activeFeatures && this.props.activeFeatures.some(f => f.featureName === 'organisation_metrics') ? (
                <NavigationItem
                  button
                  component={Link}
                  to="/metrics"
                  allowed={ROLES_CLIENT}
                  profile={profile}
                >
                  <Icon color={"primary"}>pie_chart</Icon>
                  <ListItemText primary={translate('organisation_metrics_label')} />
                </NavigationItem>
                ) : null}
                <ListSubheader component="div">
                  {translate("administration")}
                </ListSubheader>
                {isIdealAdmin ? (
                  <NavigationItem
                    button
                    component={Link}
                    to="/dashboard"
                    allowed={ROLES_IDEAL_ADMIN}
                    profile={profile}
                  >
                    <Icon color={"primary"}>dashboard</Icon>
                    <ListItemText primary={translate('dashboard_title')} />
                  </NavigationItem>
                ) : null}
                {isIdealAdmin ? (
                  <NavigationItem
                    button
                    component={Link}
                    to="/subscription-management"
                    allowed={ROLES_IDEAL_ADMIN}
                    profile={profile}
                  >
                    <Icon color={"primary"}>subscriptions</Icon>
                    <ListItemText primary={translate('subscription_dialog_manage_subscription')} />
                  </NavigationItem>
                ) : null}
                <NavigationItem
                  button
                  component={Link}
                  to="/users"
                  allowed={ROLES_ALL}
                  profile={profile}
                >
                  <Icon color={"primary"}>people</Icon>
                  <ListItemText primary={translate("general_users")} />
                </NavigationItem>
                <NavigationItem
                  button
                  component={Link}
                  to="/organisations"
                  allowed={ROLES_IDEAL}
                  profile={profile}
                >
                  <Icon color={"primary"}>contacts</Icon>
                  <ListItemText primary={translate("general_organisations")} />
                </NavigationItem>
                <NavigationItem
                  button
                  component={Link}
                  to="/allusers"
                  allowed={ROLES_IDEAL}
                  profile={profile}
                >
                  <Icon color={"primary"}>people</Icon>
                  <ListItemText primary={translate("all_users")} />
                </NavigationItem>
                <NavigationItem
                  button
                  component={Link}
                  to="/deviceupdaterepositories"
                  allowed={ROLES_IDEAL_ADMIN}
                  profile={profile}
                >
                  <Icon color={"primary"}>folder</Icon>
                  <ListItemText primary={translate("device_update_respositories")} />
                </NavigationItem>
                <NavigationItem
                  button
                  component={Link}
                  to="/devicesoftwarereleases"
                  allowed={ROLES_IDEAL_ADMIN}
                  profile={profile}
                >
                  <Icon color={"primary"}>build</Icon>
                  <ListItemText primary={translate("device_update_releases")} />
                </NavigationItem>
                <NavigationItem
                  button
                  component={Link}
                  to="/customers"
                  allowed={ROLES_CLIENT}
                  profile={profile}
                >
                  <Icon color={"primary"}>contacts</Icon>
                  <ListItemText primary={translate("general_customers")} />
                </NavigationItem>
                <NavigationItem
                  button
                  component={Link}
                  to="/devices"
                  allowed={isIdealAdmin ? ROLES_IDEAL_ADMIN : isIdealSupport ? ROLES_IDEAL_SUPPORT : ROLES_CLIENT}
                  profile={profile}
                >
                  <Icon color={"primary"}>dock</Icon>
                  {isIdealSupport || isIdealAdmin ? (
                    <ListItemText primary={translate("find_device")} />
                  ) : (
                    <ListItemText primary={translate("general_devices")} />
                  )}
                </NavigationItem>
                {isIdealAdmin ? (
                  <NavigationItem
                    button
                    component={Link}
                    to="/restorejobs"
                    allowed={ROLES_IDEAL_ADMIN}
                    profile={profile}
                  >
                    <Icon color={"primary"}>restore</Icon>
                    <ListItemText primary={translate("restore_jobs")} />
                  </NavigationItem>
                ) : null}
                <NavigationItem
                  button
                  component={Link}
                  to="/reportlist"
                  allowed={ROLES_CLIENT}
                  profile={profile}
                >
                  <Icon color={"primary"}>insert_drive_file</Icon>
                  <ListItemText primary={translate("general_reports")} />
                </NavigationItem>
                <ListSubheader component="div">
                  FEATURE ACCESS
                </ListSubheader>
                {this.props.activeFeatures && this.props.activeFeatures.some(f => f.featureName === 'smart_flag') ? (
                  <NavigationItem
                    button
                    component={Link}
                    to="/smart-flags"
                    allowed={ROLES_CLIENT}
                    profile={profile}
                  >
                    <Icon color={"primary"}>flag</Icon>
                    <ListItemText primary={translate('smart_flags_label')} />
                  </NavigationItem>
                ) : null}
                {profile && profile.roles && profile.roles === "idealadmin" ? (
                  <React.Fragment>
                    <ListSubheader allowed={ROLES_IDEAL} component="div">
                      SYSTEM SETTINGS
                    </ListSubheader>
                    <NavigationItem
                      button
                      component={Link}
                      to="/settings"
                      allowed={ROLES_IDEAL}
                      profile={profile}
                    >
                      <Icon color={"primary"}>settings</Icon>
                      <ListItemText primary={translate("general_settings")} />
                    </NavigationItem>

                    <NavigationItem
                      button
                      component={Link}
                      to="/security"
                      allowed={ROLES_IDEAL}
                      profile={profile}
                    >
                      <Icon color={"primary"}>security</Icon>
                      <ListItemText primary={translate("security")} />
                    </NavigationItem>
                  </React.Fragment>
                ) : null}
                <NavigationItem
                  button
                  component={Link}
                  to="/subtestsettings"
                  allowed={ROLES_CLIENT_ADMIN}
                  profile={profile}
                >
                  <Icon color={"primary"}>settings_applications</Icon>
                  <ListItemText
                    primary={translate("general_default_sub_test_settings")}
                  />
                </NavigationItem>
                {this.props.activeFeatures && this.props.activeFeatures.some(f => f.featureName === 'geolocation_device_lock') ? (
                <NavigationItem
                  button
                  component={Link}
                  to="/locationTracking"
                  allowed={ROLES_CLIENT_ADMIN}
                  profile={profile}
                >
                  <Icon color={"primary"}>location_on</Icon>
                  <ListItemText
                    primary={translate('location_tracking')}
                  />
                </NavigationItem>
                ) : null}
              </List>
              <Divider />
              <List>
                {/* <ListItem className={classes.navItems} button>
                  <ListItemText primary="Logout" />
                </ListItem> */}
                <ListItem
                  className={classes.navItems}
                  button
                  onClick={e => {
                    window.open(HELP_PAGE_URL, "_blank");
                  }}
                >
                  <Icon color={"primary"}>help</Icon>
                  <ListItemText
                    primary={translate ? translate("general_help") : "Help"}
                  />
                </ListItem>
                <ListItem
                  className={classes.navItems}
                  button
                  onClick={e => {
                    window.open(SUPPORT_PAGE_URL, "_blank");
                  }}
                >
                  <Icon color={"primary"}>headset_mic</Icon>
                  <ListItemText
                    primary={
                      translate ? translate("general_support") : "Support"
                    }
                  />
                </ListItem>
                {hasLrpFreeFeatures && <ListItem
                  className={classes.navItems}
                  button
                  onClick={e => {
                    window.open(teamViewerUrl, "_blank");
                  }}
                >
                  <Icon color={"primary"}>tv</Icon>
                  <ListItemText
                    primary={
                      "TeamViewer"
                    }
                  />
                </ListItem>}
              </List>
            </div>
          </div>
        </Drawer>
        {children}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  status: state.navigationReducer.status,
  profile: state.profileReducer.profile,
  activeFeatures: state.appSettingReducer.activeFeatures,
  teamViewerUrl: state.appSettingReducer.teamViewerUrl,
  ...state
});

const mapDispatchToProps = (dispatch, props) => ({
  get: () => {
    dispatch(getNavigationStatus());
  },
  set: status => {
    dispatch(setNavigationStatus(status));
  }
});

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Navigation);
